// extracted by mini-css-extract-plugin
export var tosLink = "_ba-0";